import { useMemo, useState } from "react";
import { ArrowUpDown, ChevronLeft, ChevronRight } from "lucide-react";

export function DataTable({ columns, rows, testId, pageSize = 12 }) {
  const [sort, setSort] = useState({ key: null, dir: 1 });
  const [page, setPage] = useState(0);

  const sorted = useMemo(() => {
    if (!sort.key) return rows;
    return [...rows].sort((a, b) => (a[sort.key] > b[sort.key] ? 1 : a[sort.key] < b[sort.key] ? -1 : 0) * sort.dir);
  }, [rows, sort]);

  const pages = Math.max(1, Math.ceil(sorted.length / pageSize));
  const p = Math.min(page, pages - 1);
  const slice = sorted.slice(p * pageSize, (p + 1) * pageSize);

  return (
    <div data-testid={testId}>
      <div className="overflow-x-auto rounded-md border border-slate-800">
        <table className="w-full text-sm">
          <thead className="bg-slate-900/80">
            <tr>
              {columns.map((c) => (
                <th
                  key={c.key}
                  onClick={() => setSort((s) => ({ key: c.key, dir: s.key === c.key ? -s.dir : 1 }))}
                  className={`px-3 py-2.5 font-mono text-[11px] uppercase tracking-wider text-slate-400 cursor-pointer select-none hover:text-white ${c.num ? "text-right" : "text-left"}`}
                  data-testid={`${testId}-sort-${c.key}`}
                >
                  <span className="inline-flex items-center gap-1">{c.label}<ArrowUpDown className="h-3 w-3 opacity-50" /></span>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {slice.map((r, i) => (
              <tr key={i} className="border-t border-slate-800/70 hover:bg-slate-800/40 transition-colors" data-testid={`${testId}-row-${i}`}>
                {columns.map((c) => (
                  <td key={c.key} className={`px-3 py-2 ${c.num ? "text-right font-mono" : ""}`}>
                    {c.render ? c.render(r) : r[c.key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex items-center justify-between mt-3 text-xs text-slate-500 font-mono">
        <span data-testid={`${testId}-count`}>{sorted.length.toLocaleString()} rows</span>
        <div className="flex items-center gap-2">
          <button data-testid={`${testId}-prev`} disabled={p === 0} onClick={() => setPage(p - 1)} className="p-1 rounded hover:bg-slate-800 disabled:opacity-30">
            <ChevronLeft className="h-4 w-4" />
          </button>
          <span>{p + 1} / {pages}</span>
          <button data-testid={`${testId}-next`} disabled={p >= pages - 1} onClick={() => setPage(p + 1)} className="p-1 rounded hover:bg-slate-800 disabled:opacity-30">
            <ChevronRight className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
